// Fallback document checklist.
//
// This list used to be the source of truth, duplicated from kandor-api's
// flaskr/core/application_document_catalog.py. It is no longer: the backend
// resolves a student's requirements from this baseline *plus* whatever a
// Perplexity refresh found for the courses they applied to, and returns the
// result in the /application-documents `groups` response.
//
// So prefer the API's groups. This is what to render when the API returned
// nothing - an unauthenticated preview, a failed load, or the flat-documents
// fixture path - and nothing more.
//
// `high_school_transcript` replaced the former `_v1` / `_v2` pair, which were a
// modelling artifact rather than two documents. Both upload tables were migrated.

export const APPLICATION_DOCUMENT_REQUIREMENTS = [
	{
		id: '12th_grade_transcript',
		title: '12th Grade Transcript',
		groupId: 'transcripts',
		groupTitle: 'Transcripts Uploaded',
		sortOrder: 10,
	},
	{
		id: 'college_application',
		title: 'College Application',
		groupId: 'transcripts',
		groupTitle: 'Transcripts Uploaded',
		sortOrder: 20,
	},
	{
		id: 'high_school_transcript',
		title: 'High School Transcript',
		groupId: 'transcripts',
		groupTitle: 'Transcripts Uploaded',
		sortOrder: 30,
	},
	{
		id: 'job_application',
		title: 'Job Application',
		groupId: 'transcripts',
		groupTitle: 'Transcripts Uploaded',
		sortOrder: 50,
	},
	{
		id: 'scholarship_application',
		title: 'Scholarship Application',
		groupId: 'transcripts',
		groupTitle: 'Transcripts Uploaded',
		sortOrder: 60,
	},
	{
		id: 'internship_application',
		title: 'Internship Application',
		groupId: 'transcripts',
		groupTitle: 'Transcripts Uploaded',
		sortOrder: 70,
	},
	{
		id: 'ielts_scores',
		title: 'IELTS Test Scores',
		groupId: 'tests',
		groupTitle: 'Standardized Test Scores',
		sortOrder: 10,
	},
	{
		id: 'gre_scores',
		title: 'GRE Test Scores',
		groupId: 'tests',
		groupTitle: 'Standardized Test Scores',
		sortOrder: 20,
	},
	{
		id: 'portfolio',
		title: 'Portfolio',
		groupId: 'portfolio',
		groupTitle: 'Portfolio and Resume',
		sortOrder: 10,
	},
	{
		id: 'resume',
		title: 'Resume',
		groupId: 'portfolio',
		groupTitle: 'Portfolio and Resume',
		sortOrder: 20,
	},
]

// Only a fallback denominator. The real one is the number of requirements the
// API returned for this student - see countRequirements.
export const APPLICATION_DOCUMENTS_MAX = APPLICATION_DOCUMENT_REQUIREMENTS.length

// How many distinct requirements a set of rendered groups covers. Rows are
// per file, not per requirement, so a student holding two transcripts must not
// count as two requirements satisfied.
export const countRequirements = groups => {
	const ids = new Set()
	for (const group of groups || []) {
		for (const item of group?.items || []) {
			if (item?.requirementId) ids.add(item.requirementId)
		}
	}
	return ids.size
}

export const APPLICATION_DOCUMENT_GROUPS = (() => {
	const groups = new Map()
	for (const req of APPLICATION_DOCUMENT_REQUIREMENTS) {
		if (!groups.has(req.groupId)) {
			groups.set(req.groupId, {
				id: req.groupId,
				title: req.groupTitle,
				requirements: [],
			})
		}
		groups.get(req.groupId).requirements.push(req)
	}
	return [...groups.values()]
})()
